import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfo } from "@fortawesome/sharp-solid-svg-icons"
import { Box, styled, Typography } from "@mui/material"
import { extraColors } from "../../utils/theme"
import { GradientBorder } from "../Shared/GradientBorder"

interface AboutTheDataProps {
  children: React.ReactNode
}

const Container = styled(GradientBorder)({
  padding: "12px 18px",
  display: "flex",
  gap: 12,
  alignItems: "flex-start",
  width: "100%",
  borderRadius: 6,
})

const BadgeContainer = styled(Box)({
  position: "relative",
  width: 34,
  height: 34.5,
  flexShrink: 0,
})

const Badge = styled(Box)({
  position: "absolute",
  width: 34,
  height: 34,
  top: 0.25,
  left: 0,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: `1px solid ${extraColors.white}`,
})

const TextBlock = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 0,
  flex: "1 0 0",
  minWidth: 0,
})

const Content = styled(Typography)({
  whiteSpace: "pre-wrap",
})

export const AboutTheData: React.FC<AboutTheDataProps> = ({ children }) => {
  return (
    <Container>
      <BadgeContainer>
        <Badge>
          <FontAwesomeIcon icon={faInfo} style={{ fontSize: 14 }} />
        </Badge>
      </BadgeContainer>
      <TextBlock>
        <Typography variant="body2Bold">About the data</Typography>
        <Content variant="small1" color={extraColors.white}>
          {children}
        </Content>
      </TextBlock>
    </Container>
  )
}
